import React, { useContext, useEffect, useState } from "react"
import FocusTrap from "focus-trap-react"
import { LangContext } from "./LangContext"
import { Link } from "react-router-dom"

const NewLetterForm = (props) => {
  const [lang] = useContext(LangContext)

  const [country, setCountry] = useState("")

  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"
    script.async = true
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <>
      <FocusTrap active={props.newsletterActive ? true : false}>
        <div className="newsletter" role="dialog" aria-hidden={props.newsletterActive ? "false" : "true"}>
          <div className={props.newsletterActive ? "newsletter__modal is-active" : "newsletter__modal"}>
            <div className="newsletter__modal-header">
              <h2>{lang === "fi" ? "Tilaa uutiskirje" : "Subscribe to our newsletter"}</h2>
              <button
                tabIndex={props.newsletterActive ? "0" : "-1"}
                className="newsletter__close"
                onClick={() => props.handleNewsLetter()}
                aria-label={lang === "fi" ? "Sulje" : "Close"}
              >
                {/* <ion-icon name="close-sharp" style={{ fontSize: "27px" }}></ion-icon> */}✕
              </button>
            </div>
            <div className="newsletter__form">
              <form
                className="js-cm-form"
                id="subForm"
                action="https://www.createsend.com/t/subscribeerror?description="
                method="post"
                data-id="5B5E7037DA78A748374AD499497E309EFE2A83BF4567869852248F33B27E4FD5083FD3B7012CEB4714E0AAB278E01EBD70670E0C791F16C15D2365F789657CD4"
              >
                <div>
                  <div className="form-field">
                    <label htmlFor="fieldEmail">{lang === "fi" ? "Sähköposti*" : "Email*"}</label>
                    <input
                      tabIndex={props.newsletterActive ? "0" : "-1"}
                      placeholder={lang === "fi" ? "Sähköposti*" : "Email*"}
                      aria-label="Email"
                      className="js-cm-email-input qa-input-email"
                      id="fieldEmail"
                      maxLength="200"
                      name="cm-bcjiit-bcjiit"
                      required
                      type="email"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="fielddintjkk">{lang === "fi" ? "Etunimi" : "First name"}</label>
                    <input
                      tabIndex={props.newsletterActive ? "0" : "-1"}
                      placeholder={lang === "fi" ? "Etunimi" : "First name"}
                      type="text"
                      aria-label="first name"
                      id="fielddintjkk"
                      maxLength="200"
                      name="cm-f-dintjkk"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="fielddintjku">{lang === "fi" ? "Sukunimi" : "Last name"}</label>
                    <input
                      tabIndex={props.newsletterActive ? "0" : "-1"}
                      placeholder={lang === "fi" ? "Sukunimi" : "Last name"}
                      type="text"
                      aria-label="last name"
                      id="fielddintjku"
                      maxLength="200"
                      name="cm-f-dintjku"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="fielddintjul">{lang === "fi" ? "Titteli" : "Position"}</label>
                    <input
                      tabIndex={props.newsletterActive ? "0" : "-1"}
                      placeholder={lang === "fi" ? "Titteli" : "Position"}
                      type="text"
                      aria-label="position"
                      id="fielddintjul"
                      maxLength="200"
                      name="cm-f-dintjul"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="fielddintjur">{lang === "fi" ? "Yritys" : "Organization"}</label>
                    <input
                      tabIndex={props.newsletterActive ? "0" : "-1"}
                      placeholder={lang === "fi" ? "Yritys" : "Organization"}
                      type="text"
                      aria-label="organization"
                      id="fielddintjur"
                      maxLength="200"
                      name="cm-f-dintjur"
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="fielddintjui">{lang === "fi" ? "Maa" : "Country"}</label>
                    <span className="select-wrap">
                      <select
                        tabIndex={props.newsletterActive ? "0" : "-1"}
                        aria-label="country"
                        id="fielddintjui"
                        name="cm-fo-dintjui"
                        className={country === "" ? "placeholder" : ""}
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                      >
                        <option disabled="" value="">
                          {lang === "fi" ? "Maa" : "Country"}
                        </option>

                        <option value="19932780">Afghanistan</option>

                        <option value="19932781">Albania</option>

                        <option value="19932782">Algeria</option>

                        <option value="19932783">American Samoa</option>

                        <option value="19932784">Andorra</option>

                        <option value="19932785">Angola</option>

                        <option value="19932786">Anguilla</option>

                        <option value="19932787">Antigua &amp; Barbuda</option>

                        <option value="19932788">Argentina</option>

                        <option value="19932789">Armenia</option>

                        <option value="19932790">Aruba</option>

                        <option value="19932791">Australia</option>

                        <option value="19932792">Austria</option>

                        <option value="19932793">Azerbaijan</option>

                        <option value="19932794">Azores</option>

                        <option value="19932795">Bahamas</option>

                        <option value="19932796">Bahrain</option>

                        <option value="19932797">Bangladesh</option>

                        <option value="19932798">Barbados</option>

                        <option value="19932799">Belarus</option>

                        <option value="19932800">Belgium</option>

                        <option value="19932801">Belize</option>

                        <option value="19932802">Benin</option>

                        <option value="19932803">Bermuda</option>

                        <option value="19932804">Bhutan</option>

                        <option value="19932805">Bolivia</option>

                        <option value="19932806">Bonaire</option>

                        <option value="19932807">Bosnia &amp; Herzegovina</option>

                        <option value="19932808">Botswana</option>

                        <option value="19932809">Brazil</option>

                        <option value="19932810">British Indian Ocean Ter</option>

                        <option value="19932811">Brunei</option>

                        <option value="19932812">Bulgaria</option>

                        <option value="19932813">Burkina Faso</option>

                        <option value="19932814">Burundi</option>

                        <option value="19932815">Cambodia</option>

                        <option value="19932816">Cameroon</option>

                        <option value="19932817">Canada</option>

                        <option value="19932818">Canary Islands</option>

                        <option value="19932819">Cape Verde</option>

                        <option value="19932820">Cayman Islands</option>

                        <option value="19932821">Central African Republic</option>

                        <option value="19932822">Chad</option>

                        <option value="19932823">Channel Islands</option>

                        <option value="19932824">Chile</option>

                        <option value="19932825">China</option>

                        <option value="19932826">Christmas Island</option>

                        <option value="19932827">Cocos Island</option>

                        <option value="19932828">Colombia</option>

                        <option value="19932829">Comoros</option>

                        <option value="19932830">Congo</option>

                        <option value="19932831">Congo Democratic Rep</option>

                        <option value="19932832">Cook Islands</option>

                        <option value="19932833">Costa Rica</option>

                        <option value="19932834">Cote D'Ivoire</option>

                        <option value="19932835">Croatia</option>

                        <option value="19932836">Cuba</option>

                        <option value="19932837">Curacao</option>

                        <option value="19932838">Cyprus</option>

                        <option value="19932839">Czech Republic</option>

                        <option value="19932840">Denmark</option>

                        <option value="19932841">Djibouti</option>

                        <option value="19932842">Dominica</option>

                        <option value="19932843">Dominican Republic</option>

                        <option value="19932844">East Timor</option>

                        <option value="19932845">Ecuador</option>

                        <option value="19932846">Egypt</option>

                        <option value="19932847">El Salvador</option>

                        <option value="19932848">Equatorial Guinea</option>

                        <option value="19932849">Eritrea</option>

                        <option value="19932850">Estonia</option>

                        <option value="19932851">Ethiopia</option>

                        <option value="19932852">Falkland Islands</option>

                        <option value="19932853">Faroe Islands</option>

                        <option value="19932854">Fiji</option>

                        <option value="19932855">Finland</option>

                        <option value="19932856">France</option>

                        <option value="19932857">French Guiana</option>

                        <option value="19932858">French Polynesia</option>

                        <option value="19932859">French Southern Ter</option>

                        <option value="19932860">Gabon</option>

                        <option value="19932861">Gambia</option>

                        <option value="19932862">Georgia</option>

                        <option value="19932863">Germany</option>

                        <option value="19932864">Ghana</option>

                        <option value="19932865">Gibraltar</option>

                        <option value="19932866">Great Britain</option>

                        <option value="19932867">Greece</option>

                        <option value="19932868">Greenland</option>

                        <option value="19932869">Grenada</option>

                        <option value="19932870">Guadeloupe</option>

                        <option value="19932871">Guam</option>

                        <option value="19932872">Guatemala</option>

                        <option value="19932873">Guernsey</option>

                        <option value="19932874">Guinea</option>

                        <option value="19932875">Guinea-Bissau</option>

                        <option value="19932876">Guyana</option>

                        <option value="19932877">Haiti</option>

                        <option value="19932878">Honduras</option>

                        <option value="19932879">Hong Kong</option>

                        <option value="19932880">Hungary</option>

                        <option value="19932881">Iceland</option>

                        <option value="19932882">India</option>

                        <option value="19932883">Indonesia</option>

                        <option value="19932884">Iran</option>

                        <option value="19932885">Iraq</option>

                        <option value="19932886">Ireland</option>

                        <option value="19932887">Isle of Man</option>

                        <option value="19932888">Israel</option>

                        <option value="19932889">Italy</option>

                        <option value="19932890">Jamaica</option>

                        <option value="19932891">Japan</option>

                        <option value="19932892">Jersey</option>

                        <option value="19932893">Jordan</option>

                        <option value="19932894">Kazakhstan</option>

                        <option value="19932895">Kenya</option>

                        <option value="19932896">Kiribati</option>

                        <option value="19932897">Korea North</option>

                        <option value="19932898">Korea South</option>

                        <option value="19932899">Kuwait</option>

                        <option value="19932900">Kyrgyzstan</option>

                        <option value="19932901">Laos</option>

                        <option value="19932902">Latvia</option>

                        <option value="19932903">Lebanon</option>

                        <option value="19932904">Lesotho</option>

                        <option value="19932905">Liberia</option>

                        <option value="19932906">Libya</option>

                        <option value="19932907">Liechtenstein</option>

                        <option value="19932908">Lithuania</option>

                        <option value="19932909">Luxembourg</option>

                        <option value="19932910">Macau</option>

                        <option value="19932911">Macedonia</option>

                        <option value="19932912">Madagascar</option>

                        <option value="19932913">Malawi</option>

                        <option value="19932914">Malaysia</option>

                        <option value="19932915">Maldives</option>

                        <option value="19932916">Mali</option>

                        <option value="19932917">Malta</option>

                        <option value="19932918">Marshall Islands</option>

                        <option value="19932919">Martinique</option>

                        <option value="19932920">Mauritania</option>

                        <option value="19932921">Mauritius</option>

                        <option value="19932922">Mayotte</option>

                        <option value="19932923">Mexico</option>

                        <option value="19932924">Midway Islands</option>

                        <option value="19932925">Moldova</option>

                        <option value="19932926">Monaco</option>

                        <option value="19932927">Mongolia</option>

                        <option value="19932928">Montenegro</option>

                        <option value="19932929">Montserrat</option>

                        <option value="19932930">Morocco</option>

                        <option value="19932931">Mozambique</option>

                        <option value="19932932">Myanmar</option>

                        <option value="19932933">Namibia</option>

                        <option value="19932934">Nauru</option>

                        <option value="19932935">Nepal</option>

                        <option value="19932936">Netherland Antilles</option>

                        <option value="19932937">Netherlands</option>

                        <option value="19932938">Nevis</option>

                        <option value="19932939">New Caledonia</option>

                        <option value="19932940">New Zealand</option>

                        <option value="19932941">Nicaragua</option>

                        <option value="19932942">Niger</option>

                        <option value="19932943">Nigeria</option>

                        <option value="19932944">Niue</option>

                        <option value="19932945">Norfolk Island</option>

                        <option value="19932946">Norway</option>

                        <option value="19932947">Oman</option>

                        <option value="19932948">Pakistan</option>

                        <option value="19932949">Palau Island</option>

                        <option value="19932950">Palestine</option>

                        <option value="19932951">Panama</option>

                        <option value="19932952">Papua New Guinea</option>

                        <option value="19932953">Paraguay</option>

                        <option value="19932954">Peru</option>

                        <option value="19932955">Philippines</option>

                        <option value="19932956">Pitcairn Island</option>

                        <option value="19932957">Poland</option>

                        <option value="19932958">Portugal</option>

                        <option value="19932959">Puerto Rico</option>

                        <option value="19932960">Qatar</option>

                        <option value="19932961">Reunion</option>

                        <option value="19932962">Romania</option>

                        <option value="19932963">Russia</option>

                        <option value="19932964">Rwanda</option>

                        <option value="19932965">Saipan</option>

                        <option value="19932966">Samoa</option>

                        <option value="19932967">Samoa American</option>

                        <option value="19932968">San Marino</option>

                        <option value="19932969">Sao Tome &amp; Principe</option>

                        <option value="19932970">Saudi Arabia</option>

                        <option value="19932971">Senegal</option>

                        <option value="19932972">Serbia</option>

                        <option value="19932973">Serbia &amp; Montenegro</option>

                        <option value="19932974">Seychelles</option>

                        <option value="19932975">Sierra Leone</option>

                        <option value="19932976">Singapore</option>

                        <option value="19932977">Slovakia</option>

                        <option value="19932978">Slovenia</option>

                        <option value="19932979">Solomon Islands</option>

                        <option value="19932980">Somalia</option>

                        <option value="19932981">South Africa</option>

                        <option value="19932982">South Sudan</option>

                        <option value="19932983">Spain</option>

                        <option value="19932984">Sri Lanka</option>

                        <option value="19932985">St Barthelemy</option>

                        <option value="19932986">St Eustatius</option>

                        <option value="19932987">St Helena</option>

                        <option value="19932988">St Kitts-Nevis</option>

                        <option value="19932989">St Lucia</option>

                        <option value="19932990">St Maarten</option>

                        <option value="19932991">St Pierre &amp; Miquelon</option>

                        <option value="19932992">St Vincent &amp; Grenadines</option>

                        <option value="19932993">Sudan</option>

                        <option value="19932994">Suriname</option>

                        <option value="19932995">Swaziland</option>

                        <option value="19932996">Sweden</option>

                        <option value="19932997">Switzerland</option>

                        <option value="19932998">Syria</option>

                        <option value="19932999">Tahiti</option>

                        <option value="19933000">Taiwan</option>

                        <option value="19933001">Tajikistan</option>

                        <option value="19933002">Tanzania</option>

                        <option value="19933003">Thailand</option>

                        <option value="19933004">Togo</option>

                        <option value="19933005">Tokelau</option>

                        <option value="19933006">Tonga</option>

                        <option value="19933007">Trinidad &amp; Tobago</option>

                        <option value="19933008">Tunisia</option>

                        <option value="19933009">Turkey</option>

                        <option value="19933010">Turkmenistan</option>

                        <option value="19933011">Turks &amp; Caicos Is</option>

                        <option value="19933012">Tuvalu</option>

                        <option value="19933013">Uganda</option>

                        <option value="19933014">Ukraine</option>

                        <option value="19933015">United Arab Emirates</option>

                        <option value="19933016">United Kingdom</option>

                        <option value="19933017">United States of America</option>

                        <option value="19933018">Uruguay</option>

                        <option value="19933019">Uzbekistan</option>

                        <option value="19933020">Vanuatu</option>

                        <option value="19933021">Vatican City State</option>

                        <option value="19933022">Venezuela</option>

                        <option value="19933023">Vietnam</option>

                        <option value="19933024">Virgin Islands (Brit)</option>

                        <option value="19933025">Virgin Islands (USA)</option>

                        <option value="19933026">Wake Island</option>

                        <option value="19933027">Wallis &amp; Futana Is</option>

                        <option value="19933028">Yemen</option>

                        <option value="19933029">Zambia</option>

                        <option value="19933030">Zimbabwe</option>
                      </select>
                    </span>
                  </div>

                  <div>
                    <div>
                      <div className="form-checkbox">
                        <input
                          tabIndex={props.newsletterActive ? "0" : "-1"}
                          required
                          id="cm-privacy-consent"
                          name="cm-privacy-consent"
                          type="checkbox"
                        />
                        <label htmlFor="cm-privacy-consent">
                          {lang === "fi" ? "Hyväksyn sähköpostien vastaanottamisen*" : "I agree to be emailed*"}
                        </label>
                      </div>
                      <input
                        tabIndex={props.newsletterActive ? "0" : "-1"}
                        id="cm-privacy-consent-hidden"
                        name="cm-privacy-consent-hidden"
                        type="hidden"
                        value="true"
                      />
                    </div>
                  </div>
                  <p style={{ marginBottom: "16px" }}>
                    <Link tabIndex={props.newsletterActive ? "0" : "-1"} to="/privacy-policy">
                      {lang === "fi" ? "Tietosuojaseloste" : "Privacy Policy"}
                    </Link>
                  </p>
                </div>
                <button tabIndex={props.newsletterActive ? "0" : "-1"} className="button" type="submit">
                  {lang === "fi" ? "Tilaa" : "Subscribe"}
                </button>
                <p className="required-info">{lang === "fi" ? `*Pakolliset kentät` : "*Required field"}</p>
              </form>
            </div>
          </div>
          <div
            tabIndex={props.newsletterActive ? "0" : "-1"}
            className={props.newsletterActive ? "newsletter__overlay is-active" : "newsletter-overlay"}
            onClick={() => props.handleNewsLetter()}
            aria-hidden={props.newsletterActive ? "false" : "true"}
          />
        </div>
      </FocusTrap>
    </>
  )
}

export default NewLetterForm
